import { FC } from "react";
import { Content } from "@prismicio/client";
import { SliceComponentProps } from "@prismicio/react";
import { PrismicNextLink } from "@prismicio/next"

/**
 * Props for `LinkButtons`.
 */
export type LinkButtonsProps = SliceComponentProps<Content.LinkButtonsSlice>;

/**
 * Component for "LinkButtons" Slices.
 */
const LinkButtons: FC<LinkButtonsProps> = ({ slice }) => {
  return (
    <section
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
    >
      <div className="max-w-[1280px] text-center mb-24 font-fellix">
      <ul>
          {slice.primary.link_buttons.map((item: any, index: number)=>{
              return (
                  <li key={index}>
                    <PrismicNextLink field={item.button_link} className="jade-hollow">
                      {item.button_text}
                    </PrismicNextLink>
                  </li>
                )
            })}
          </ul>
        </div>
    </section>
  );
};

export default LinkButtons;